<template>
  <v-container
    fluid
    tag="section"
  >
  <h1>Your Preferences</h1>
  <p>Manage your stocks preferences here. Any changes to these lists will change the recommendations that are pushed to you.</p>
    <v-row v-if="listLoad">
      <v-col
        cols="12"
        md="3"
      >
        <v-skeleton-loader type="card" width="200"  height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
      </v-col>
      
      <v-col
        cols="12"
        md="3"
      >
          <v-skeleton-loader type="card" width="200"  height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
      </v-col>

      <v-col
        cols="12"
        md="3"
      >
          <v-skeleton-loader type="card" width="200"  height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
      </v-col>

      <v-col
        cols="12"
        md="3"
      >
        <v-skeleton-loader type="card" width="200"  height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row v-if="!listLoad">
      <v-col
        cols="12"
        md="4"
      >
        <v-card
          color="lighten-1"
          class="mr-3"
          style="background: linear-gradient(to bottom, #3a98ed, #2ca9cd);"
           
        >
          <v-card-title class="d-block text-center" style="color: #13305c; font-size: 18px; font-weight: bold;">
            Preferences Category
          </v-card-title>
          <v-card-text class="text-center" style="font-size: 15px; color: white; font-weight: bold;">
            {{classification}}<br>
            <v-row>
              <v-col cols="12" md="6">
                <small style="color: #13305c;">Likes</small><br>{{classificationLike}}
              </v-col>
              <v-col cols="12" md="6">
                <small  style="color: #13305c;">Dislikes</small><br>{{classificationDislike}}
              </v-col>              
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
  
      <v-col cols="12" md="8">
        <v-skeleton-loader v-if="insightsLoad" type="card" width="200"  height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
        <v-card  height='100%' v-if="!insightsLoad">
          <v-card-title>Insights</v-card-title>
          <v-container fluid class="pa-5">
            <v-row>
              <v-col cols="12">
                <v-expansion-panels accordion multiple hover>
                  <v-expansion-panel>
                    <v-expansion-panel-header v-slot="{ open }">                    
                      <v-row  no-gutters>                      
                      <v-col cols="4">Preferences Performance</v-col>
                      <v-col
                        cols="8"
                        class="text--secondary"
                      >
                      <v-fade-transition leave-absolute> 
                        <span
                          v-if="open"
                          key="0"
                        >
                        </span>
                        <span
                          v-else
                          key="1"
                        >
                        {{insights.classificationShort}}
                        </span>
                      </v-fade-transition>
                      </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <!-- <v-row no-gutters v-if="insights.classification">
                        <v-col cols="12" md="12" >
                          {{insights.classification}}<br>
                        </v-col>                     
                      </v-row>       -->
                      <v-row no-gutters >
                        
                        <v-col cols="12" md="12" v-if="insights.stocksBest">
                          Best performers: <br>
                            <span v-for="(item, index) in insights.stocksBest" :key="item.id">
                              <v-menu>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    :color="getColorBasedOnPerf(item.perf)"
                                    text
                                    small 
                                    v-bind="attrs"
                                    v-on="on"                                
                                  >
                                    {{item.name}} ({{ formatPercentage(item.perf) }})
                                  </v-btn>
                                </template>
                                <v-list>
                                  <v-subheader>{{item.name}} <stock-menu :stock="item.id" :title="item.name" :preference="item.preference"></stock-menu></v-subheader>
                                  <v-list-item>
                                    <v-list-item-title>{{item.text}}</v-list-item-title>                      
                                  </v-list-item>
                                </v-list>
                              </v-menu>  

                              <span v-if="index < insights.stocksBest.length - 2">,</span>
                              <span v-if="index === insights.stocksBest.length -2">and</span>

                            </span>.                          
                        </v-col> 
                        <v-col cols="12" md="12" v-if="insights.stocksWorst">
                          Worst performers: <br>
                            <span v-for="(item, index) in insights.stocksWorst" :key="item.id">
                              <v-menu>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    :color="getColorBasedOnPerf(item.perf)"
                                    text
                                    small 
                                    v-bind="attrs"
                                    v-on="on"                                
                                  >
                                    {{item.name}} ({{ formatPercentage(item.perf) }})
                                  </v-btn>
                                </template>
                                <v-list>
                                  <v-subheader>{{item.name}} <stock-menu :stock="item.id" :title="item.name" :preference="item.preference"></stock-menu></v-subheader>
                                  <v-list-item>
                                    <v-list-item-title>{{item.text}}</v-list-item-title>                      
                                  </v-list-item>
                                </v-list>
                              </v-menu>  

                              <span v-if="index < insights.stocksBest.length - 2">,</span>
                              <span v-if="index === insights.stocksBest.length -2">and</span>

                            </span>.  
                        </v-col>                                           
                      </v-row>                                     
                    </v-expansion-panel-content>
                  </v-expansion-panel>             
                  <v-expansion-panel>
                    <v-expansion-panel-header v-slot="{ open }">                    
                      <v-row  no-gutters>                      
                        <v-col cols="4">Preferences and Portfolio Moves</v-col>
                      <v-col
                        cols="8"
                        class="text--secondary"
                      >
                      <v-fade-transition leave-absolute> 
                        <span
                          v-if="open"
                          key="0"
                        >
                        </span>
                        <span
                          v-else
                          key="1"
                        >
                        {{insights.conflictShort}}
                        </span>
                      </v-fade-transition>
                      </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row no-gutters >
                        <v-col cols="12" md="12" v-if="insights.conflict">
                          <ul v-for="item in insights.conflict" :key="item.id">
                            <li>{{item.name}} : {{item.text}} 
                                  <v-menu offset-y>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      color="primary"
                                      v-bind="attrs"
                                      v-on="on"
                                      text small 
                                    >
                                      +
                                    </v-btn>
                                  </template>
                                  <v-list>
                                    <v-subheader>{{item.name}} conflicting portfolio(s)</v-subheader>
                                    <v-list-item
                                      v-for="(itemPtf, index) in item.listPtf"
                                      :key="index"
                                      :to="'portfolio/analyze/' + itemPtf.mnemonic"
                                    >
                                      <v-list-item-title>{{ itemPtf.mnemonic }} - {{ itemPtf.date_constituents}}</v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                            </li>
                          </ul>
                        </v-col>                    
                      </v-row>                    
                    </v-expansion-panel-content>
                  </v-expansion-panel>
              </v-expansion-panels> 

              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      
    </v-row>
    

  <v-row >
    <v-col
      cols="12" md = "6"
    >
      <v-card
        class="mx-auto"
        min-height="400"
      >
        <v-card-title> 
          <v-row >
            <v-col>
              Liked Stocks 
            </v-col>      
            <v-spacer></v-spacer>              
            <v-col class="text-right">
              <!-- <v-btn color="primary" small class="mr-0" outlined >  <v-icon left small >mdi-thumb-up</v-icon>Add Like</v-btn> -->
            </v-col>
          </v-row>          
        </v-card-title>
        <v-card-text>
          <v-skeleton-loader v-if="listLoad" type="table"></v-skeleton-loader>
          <v-data-table
            :disable-sort="true"
            :disable-pagination="true"
            hide-default-footer
            v-show="!listLoad"
            :headers="headers"
            :items="likes"
            :mobile-breakpoint="0"
          >
            <template v-slot:item="row">
              <tr >
                <td>
                  <v-btn
                    class="px-2 mr-2"
                    color="primary"
                    min-width="0"
                    icon
                    small
                    :to="'/stocks/analyze/' + row.item.id"
                  >
                    <v-icon>
                      mdi-magnify-plus-outline
                    </v-icon>
                  </v-btn>
                </td>                  
                <td>{{ row.item.name }}</td>
                <td>{{ row.item.ric }}</td>
                <td>{{ row.item.ticker }}</td>
                <td>{{ row.item.country }}</td>
                <td>{{ row.item.sector }}</td>
                <td>
                  <stock-set-preference :stock="row.item.id" :rating="row.item.like_dislike" :update="row.item.update"></stock-set-preference>
                </td>
              </tr>
            </template>
          </v-data-table>      
        </v-card-text>
      </v-card>
    </v-col>

    <v-col
      cols="12" md = "6"
    >
      <v-card
        class="mx-auto"
        min-height="400"
         height='100%'
      >
        <v-card-title>
          <v-row >
            <v-col>
              Disliked Stocks 
            </v-col>      
            <v-spacer></v-spacer>              
            <v-col class="text-right">
              <!-- <v-btn color="primary" small class="mr-0" outlined > <v-icon left small >mdi-thumb-down</v-icon>Add Stock</v-btn> -->
            </v-col>
          </v-row> 
        </v-card-title>
        <v-card-text>
          <v-skeleton-loader v-if="listLoad" type="table"></v-skeleton-loader>
          <v-data-table
            :disable-sort="true"
            :disable-pagination="true"
            hide-default-footer
            v-show="!listLoad"
            :headers="headers"
            :items="dislikes"
            :mobile-breakpoint="0"
          >
            <template v-slot:item="row">
              <tr >
                <td>
                  <v-btn
                    class="px-2 mr-2"
                    color="primary"
                    min-width="0"
                    icon
                    small
                    :to="'/stocks/analyze/' + row.item.id"
                  >
                    <v-icon>
                      mdi-magnify-plus-outline
                    </v-icon>
                  </v-btn>
                </td>                  
                <td>{{ row.item.name }}</td>
                <td>{{ row.item.ric }}</td>
                <td>{{ row.item.ticker }}</td>
                <td>{{ row.item.country }}</td>
                <td>{{ row.item.sector }}</td>
                <td>
                  <stock-set-preference :stock="row.item.id" :rating="row.item.like_dislike"></stock-set-preference>
                </td>
              </tr>
            </template>
          </v-data-table>      
        </v-card-text>
      </v-card>
    </v-col>    
  </v-row>

  <v-row >
    <v-col
      cols="12" md = "6"
    >
      <v-card
        class="mx-auto"
        min-height="400"
      >
        <v-card-title>
          Stocks you might like
        </v-card-title>
        <v-card-text>
          Stocks you could be interested in.
          <v-skeleton-loader v-if="listLoad" type="table"></v-skeleton-loader>
          <v-data-table
            :disable-sort="true"
            :disable-pagination="true"
            hide-default-footer
            v-show="!listLoad"
            :headers="headers"
            :items="mightLike"
            :mobile-breakpoint="0"
          >
            <template v-slot:item="row">
              <tr >
                <td>
                  <v-btn
                    class="px-2 mr-2"
                    color="primary"
                    min-width="0"
                    icon
                    small
                    :to="'/stocks/analyze/' + row.item.id"
                  >
                    <v-icon>
                      mdi-magnify-plus-outline
                    </v-icon>
                  </v-btn>
                </td>                  
                <td>{{ row.item.name }}</td>
                <td>{{ row.item.ric }}</td>
                <td>{{ row.item.ticker }}</td>
                <td>{{ row.item.country }}</td>
                <td>{{ row.item.sector }}</td>
                <td>
                  <stock-set-preference :stock="row.item.id" :rating="row.item.like_dislike"></stock-set-preference>
                </td>
              </tr>
            </template>
          </v-data-table>      
        </v-card-text>
      </v-card>
    </v-col>

    <v-col
      cols="12" md = "6"
    >
      <v-card
        class="mx-auto"
        min-height="400"
         height='100%'
      >
        <v-card-title>
          Stocks you might want to avoid
        </v-card-title>
        <v-card-text>
          Stocks you might want to avoid.
          <v-skeleton-loader v-if="listLoad" type="table"></v-skeleton-loader>
          <v-data-table
            :disable-sort="true"
            :disable-pagination="true"
            :mobile-breakpoint="0"
            hide-default-footer
            v-show="!listLoad"
            :headers="headers"
            :items="mightDislike"
          >
            <template v-slot:item="row">
              <tr >
                <td>
                  <v-btn
                    class="px-2 mr-2"
                    color="primary"
                    min-width="0"
                    icon
                    small
                    :to="'/stocks/analyze/' + row.item.id"
                  >
                    <v-icon>
                      mdi-magnify-plus-outline
                    </v-icon>
                  </v-btn>
                </td>                  
                <td>{{ row.item.name }}</td>
                <td>{{ row.item.ric }}</td>
                <td>{{ row.item.ticker }}</td>
                <td>{{ row.item.country }}</td>
                <td>{{ row.item.sector }}</td>
                <td>
                  <stock-set-preference :stock="row.item.id" :rating="row.item.like_dislike"></stock-set-preference>
                </td>
              </tr>
            </template>
          </v-data-table>      
        </v-card-text>
      </v-card>
    </v-col>    
  </v-row>

  <v-row >
    <v-col
      cols="12" md = "6"
    >
      <v-card
        class="mx-auto"
        min-height="400"
         height='100%'
      >
        <v-card-title>
          Implied liked stocks
        </v-card-title>
        <v-card-text>
          Potential Liked Stocks implied from your actions.
          <v-skeleton-loader v-if="listLoad" type="table"></v-skeleton-loader>
          <v-data-table
            :disable-sort="true"
            :disable-pagination="true"
            :mobile-breakpoint="0"
            hide-default-footer
            v-show="!listLoad"
            :headers="headers"
            :items="impliedLikes"
          >
            <template v-slot:item="row">
              <tr >
                <td>
                  <v-btn
                    class="px-2 mr-2"
                    color="primary"
                    min-width="0"
                    icon
                    small
                    :to="'/stocks/analyze/' + row.item.id"
                  >
                    <v-icon>
                      mdi-magnify-plus-outline
                    </v-icon>
                  </v-btn>
                </td>                  
                <td>{{ row.item.name }}</td>
                <td>{{ row.item.ric }}</td>
                <td>{{ row.item.ticker }}</td>
                <td>{{ row.item.country }}</td>
                <td>{{ row.item.sector }}</td>
                <td>
                  <stock-set-preference :stock="row.item.id" :rating="row.item.like_dislike"></stock-set-preference>
                </td>
              </tr>
            </template>
          </v-data-table>      
        </v-card-text>
      </v-card>
    </v-col>

    <v-col
      cols="12" md = "6"
    >
      <v-card
        class="mx-auto"
        min-height="400"
         height='100%'
      >
        <v-card-title>
          Implied disliked stocks
        </v-card-title>
        <v-card-text>
          Potential disliked Stocks implied from your actions.
          <v-skeleton-loader v-if="listLoad" type="table"></v-skeleton-loader>
          <v-data-table
            :disable-sort="true"
            :disable-pagination="true"
            :mobile-breakpoint="0"
            hide-default-footer
            v-show="!listLoad"
            :headers="headers"
            :items="impliedDislikes"
          >
            <template v-slot:item="row">
              <tr >
                <td>
                  <v-btn
                    class="px-2 mr-2"
                    color="primary"
                    min-width="0"
                    icon
                    small
                    :to="'/stocks/analyze/' + row.item.id"
                  >
                    <v-icon>
                      mdi-magnify-plus-outline
                    </v-icon>
                  </v-btn>
                </td>                  
                <td>{{ row.item.name }}</td>
                <td>{{ row.item.ric }}</td>
                <td>{{ row.item.ticker }}</td>
                <td>{{ row.item.country }}</td>
                <td>{{ row.item.sector }}</td>
                <td>
                  <stock-set-preference :stock="row.item.id" :rating="row.item.like_dislike"></stock-set-preference>
                </td>
              </tr>
            </template>
          </v-data-table>      
        </v-card-text>
      </v-card>
    </v-col>    
  </v-row>

  </v-container>
</template>

<script>
import moment from "moment";
import { format } from "d3-format";
export default {
  name: "UserLikes",
  components: {
    StockSetPreference: () => import("@/components/SetPreferences"),
    StockMenu: () => import('@/components/StockMenu')
  },
  data() {
    return {
      classification:'...',
      classificationLike:'...',
      classificationDislike:'...',
      insights:'...',
      likes: [],
      dislikes: [],      
      impliedLikes: [],      
      impliedDislikes: [],      
      mightLike: [],      
      mightDislike: [],                              
      headers: [
        {
          sortable: false,
          text: '',
          align: 'left',
        },          
        {
          text: 'Name',
          align: 'left',
          value: 'name',
        },
        { text: 'RIC', value: 'ric' },          
        { text: 'Ticker', value: 'ticker' },
        { text: 'Country', value: 'country' },
        { text: 'Sector', value: 'sector' },
        {
          sortable: false,
          text: 'Like',
          value: 'like_dislike',
        },
      ],      
      listLoad: true,
      insightsLoad: true,
      errorbar: false,
      errorMessage: ""
    };
  },
  mounted() {
    this.getDataFromApi();
    this.getInsightsFromApi();
  },
  methods: {
    formatPercentage(d) {
      return format("+0.0%")(d);
    },     
      getColorBasedOnPerf(contrib) {
        if (contrib>0) {
          return "primary"
        } else {
          return "#e9507f"
        }
      },     
    formatDate(value) {
      return moment(String(value)).format("YYYY-MM-DD h:mm:ss");
    },
    async getInsightsFromApi() {
      var self = this;
      const currentSession = await this.$Amplify.Auth.currentSession();
      const currentToken = currentSession.getIdToken().getJwtToken();
      this.$http
        .get(process.env.VUE_APP_API_HOST + "/get-user-preferences-insights/", {
          headers: {
            Authorization: currentToken,
            "Content-Type": "application/json"
          }
        })
        .then(function(response) {
          self.insights = response.data;          
          self.insightsLoad = false;
        })
        .catch(function() {
          self.insightsLoad = false;

        });
    },    
    async getDataFromApi() {
      var self = this;
      const currentSession = await this.$Amplify.Auth.currentSession();
      const currentToken = currentSession.getIdToken().getJwtToken();
      this.$http
        .get(process.env.VUE_APP_API_HOST + "/get-user-preferences/", {
          headers: {
            Authorization: currentToken,
            "Content-Type": "application/json"
          }
        })
        .then(function(response) {
          self.classification = response.data.classification;
          self.classificationLike = response.data.classificationLike;
          self.classificationDislike = response.data.classificationDislike;
          self.insights  = response.data.insights;
          self.likes = response.data.likes;
          self.dislikes = response.data.dislikes;    
          self.impliedLikes = response.data.impliedLikes;      
          self.impliedDislikes = response.data.impliedDislikes;     
          self.mightLike = response.data.mightLike;      
          self.mightDislike = response.data.mightDislike;            
          self.listLoad = false;
        })
        .catch(function() {
          self.listLoad = false;
          self.errorbar = true;
        });
    }
  }
};
</script>
